import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Gauge } from '@mui/x-charts';

interface HalfCircleGaugeProps {
  percentage: number;
  backgroundColor: string;
  foregroundColor: string;
  width: number;
}

const theme = createTheme({});

export const HalfCircleGauge = ({ percentage, backgroundColor, foregroundColor, width }: HalfCircleGaugeProps) => {
  return (
    <ThemeProvider theme={theme}>
      <Gauge
        width={width}
        value={percentage}
        startAngle={-90}
        endAngle={90}
        valueMin={0}
        valueMax={100}
        disableAxisListener
        sx={{
          '& .MuiGauge-valueArc': {
            fill: foregroundColor,
          },
          '& .MuiGauge-referenceArc': {
            fill: backgroundColor,
          },
          '& .MuiGauge-valueText': {
            display: 'none',
          },
        }}
      />
    </ThemeProvider>
  );
};

export default HalfCircleGauge;
